import { render, staticRenderFns } from "./NewTicketValues.vue?vue&type=template&id=14b6c9a2&"
import script from "./NewTicketValues.vue?vue&type=script&lang=js&"
export * from "./NewTicketValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports